export enum DomicilePosition {
  Background = "Background",
  Foreground = "Foreground",
}
